import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { UwGuideline } from 'types/uwService';
import ProductLineTitle from 'components/common/general/ProductLineTitle';
import { ChevronDown, ChevronUp } from '@insurancemenu/imenu-components-lib/dist/icons';
import {
  ExpandButtonStyled,
  GuidelineCardStyled,
  GuidelineRulesBlockStyled,
  ProductLineWrapperStyled,
  RuleNameStyled,
  RuleTextStyled,
} from './styles';

interface Props {
  uwGuidelines: UwGuideline[];
}

const UWGuidelines: React.FC<Props> = observer(({ uwGuidelines }) => {
  const [expand, setExpand] = useState(false);

  function toggleExpand(): void {
    setExpand(!expand);
  }

  return (
    <GuidelineCardStyled>
      <ExpandButtonStyled
        collapsed={!expand}
        type="text"
        rightIconProp={expand ? <ChevronUp /> : <ChevronDown />}
        onClick={toggleExpand}
      >
        Underwriting Guidelines
      </ExpandButtonStyled>
      {expand &&
        uwGuidelines.map((guideline) => (
          <ProductLineWrapperStyled key={`${guideline.productLineId}_section`}>
            <ProductLineTitle productLineId={guideline.productLineId} />
            <GuidelineRulesBlockStyled>
              {Object.keys(guideline.rules).map((rule) => (
                <p key={`${guideline.productLineId}_${rule}`}>
                  <RuleNameStyled>{rule.split('_').join(' ')}: </RuleNameStyled>
                  <RuleTextStyled>{guideline.rules[rule]}</RuleTextStyled>
                </p>
              ))}
            </GuidelineRulesBlockStyled>
          </ProductLineWrapperStyled>
        ))}
    </GuidelineCardStyled>
  );
});

export default UWGuidelines;
